/*create by BaiZhiming 2015-12-14*/
'use strict';
angular.module('batchGeneratingModule', []).controller('batchGeneratingCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    '$timeout',
    '$stateParams',
    '$filter',
    'trsHttpService',
    'modalDialog',
    'getWebsiteNameService',
    'trsColumnTreeLocationService',
    'platform',
    function(
        $scope,
        $q,
        $modalInstance,
        $timeout,
        $stateParams,
        $filter,
        trsHttpService,
        modalDialog,
        getWebsiteNameService,
        trsColumnTreeLocationService,
        platform
    ) {
        init();
        initStatus();

        function initStatus() {
            /**
             * [cur description]记录渠道 站点 报纸等当前选中状态
             * @type {Object}
             */
            $scope.cur = {
                currMedia: {},
                currSite: {},
                currChannel: {},
                currDieci: {},
            };
            $scope.status = {
                selectedArr: {
                    //各渠道下被选中的集合
                    website: {},
                },
            };
            $scope.data = {
                website: {
                    columns: [], //栏目
                },
                app: {
                    columns: [], //栏目
                },
                selectedNode: {}, //树结构上被选中的节点
                appSelectedNode: {},
            };
        }
        $scope.showToggle = function(node) {
            if (node.HASCHILDREN === 'true' && node.CHILDREN.length === 0) {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryClassifyByChnl',
                    ChannelId: node.CHANNELID,
                    platform: platform,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    node.CHILDREN = data.CHILDREN;
                });
            }
        };

        $scope.confirm = function() {
            if (angular.isDefined($scope.genParams.ChannelId)) {
                if (parseInt($scope.genParams.EndDocId) < parseInt($scope.genParams.BeginDocId)) {
                    modalDialog.alertType('操作失败', '', 'warning', false);
                } else {
                    $scope.genParams.serviceid = 'mlf_website';
                    $scope.genParams.methodname = 'batchUpdateDocs';
                    $scope.genParams.StartDocPubTime = $filter('date')($scope.genParams.StartDocPubTime, 'yyyy-MM-dd hh:mm');
                    $scope.genParams.EndDocPubTime = $filter('date')($scope.genParams.EndDocPubTime, 'yyyy-MM-dd hh:mm');
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.genParams, 'post').then(function(data) {
                        modalDialog.alertType('操作成功', '', 'success', false);
                        $modalInstance.dismiss();
                    });
                }
            } else {
                modalDialog.alertType('请先选择栏目', '', 'warning', false);
            }
        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        function init() {
            $scope.isReadonly = true;
            $scope.websiteTemplate = {
                name: '请选择模板',
                value: 0,
            };
            $scope.status = {
                onlyMine: false,
                selectedItem: {},
            };
            $scope.treeOptions = {
                nodeChildren: 'CHILDREN',
                allowDeselect: false,
                dirSelectable: true,
                injectClasses: {
                    ul: 'a1',
                    li: 'a2',
                    liSelected: 'a7',
                    iExpanded: 'a3',
                    iCollapsed: 'a4',
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'a8',
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN == 'false';
                },
            };
            //树配置结束
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyBySite',
                SiteId: $stateParams.siteid,
                platform: platform,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.siteDesc = data.SITEDESC; //将请求到的树拆分
                $scope.siteId = data.SITEID;
                $scope.dataForTheTree = data;
                $scope.showTree = true;
            });
            $scope.recuGens = [
                {
                    desc: '是',
                    value: 1,
                },
                {
                    desc: '否',
                    value: 0,
                },
            ];
            $scope.selectedRecuGen = 0;
            getWebsiteNameService.getWebsiteName($stateParams.siteid).then(function(data) {
                $scope.channelName = data.SITEDESC;
            });
            $scope.genParams = {
                StartDocPubTime: angular.copy(new Date()),
                EndDocPubTime: angular.copy(new Date()),
                Recursion: false,
            };
        }

        $scope.chooseChannel = function(node) {
            if (node.CHANNELID == $scope.channelid) {
                return;
            }
            if (angular.isDefined($scope.selectedChannel) && $scope.selectedChannel != null) {
                if ($scope.selectedChannel.CHANNELID === node.CHANNELID) {
                    $scope.selectedChannel = null;
                } else {
                    $scope.selectedChannel = node;
                }
            } else {
                $scope.selectedChannel = node;
            }
            /*node.isSelected = node.isSelected === true ? false : true;
            console.log(node.isSelected);
            if (node.isSelected) {
                $scope.selectedChannel = node;
            } else {
                $scope.selectedChannel = null;
            }*/
            /*if (event.target.checked) {
                $scope.selectedChannel = node;
            }*/
        };

        /**
         * [getWebsiteColumn description]获得网站站点下的栏目
         * @param  {[obj]} site [description]当前站点信息
         * @return {[type]}      [description]
         */
        function getWebsiteColumn(siteId) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyBySite',
                SiteId: siteId,
                platform: platform,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.dataForTheTree = data;
                deffer.resolve(data);
            });
            return deffer.promise;
        }
        /**
         *[getSuggestions description]搜索栏目
         * @param  {[type]}channelname  [description] 输入栏目名称3
         * return {[type]}   null  [description]
         */
        var promise;
        $scope.getWebsiteChnl = function(channelName, type) {
            if (channelName === '') return;
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            var siteid = $scope.siteId;
            promise = $timeout(function() {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryRightClassifyByName',
                    ChannelName: channelName,
                    SiteId: siteid,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    return data;
                });
            }, 500);
            return promise;
        };

        $scope.$watch('data.channelFilter', function(newValue, oldValue) {
            if (angular.isObject(newValue)) {
                //初始化树数据
                getWebsiteColumn($scope.siteId);
                //清空树展开
                $scope.data.expandedTest = [];
                //赋值选中栏目
                $scope.genParams.ChannelId = newValue.CHANNELID;
                trsColumnTreeLocationService.columnTreeLocation(
                    1,
                    newValue.CHANNELID,
                    $scope.dataForTheTree,
                    $scope.data.selectedNode,
                    $scope.data.expandedTest,
                    function(tree, array) {
                        delete $scope.dataForTheTree;
                        $scope.dataForTheTree = tree;
                        $scope.status.selectedArr.website[$scope.siteId] = array.pop();
                    }
                );
            }
        });
        //稿源
        function template(node) {
            var params = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'getOptionalTemplates',
                ObjectType: '101',
                ObjectId: node.CHANNELID,
                TEMPLATETYPE: '2',
                DocTemp: true,
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post').then(function(data) {
                var templateJson = data.DATA;
                var channel = [];
                channel.push({
                    name: '请选择模板',
                    value: '',
                });
                for (var key in templateJson) {
                    channel.push({
                        name: templateJson[key].TEMPNAME,
                        value: templateJson[key].TEMPID,
                    });
                    if (templateJson[key].DEFAULTTEMP == 1) {
                        $scope.websiteTemplate = {
                            name: templateJson[key].TEMPNAME,
                            value: templateJson[key].TEMPID,
                        };
                    }
                }
                $scope.templateJson = channel;
                $scope.genParams.TempId = $scope.websiteTemplate.value;
            });
        }
        /**
         * [getSuggestions description]作者suggestion
         * @param  {[type]} viewValue [description]
         * @return {[type]}           [description]
         */
        $scope.getSuggestions = function(viewValue) {
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'queryUsersByName',
                IsSearchAll: true,
                Name: viewValue,
            };
            if (viewValue !== '') {
                if ($scope.isRequest) {
                    $scope.isRequest = false;
                    return [];
                } else {
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        return data;
                    });
                }
            }
        };

        /**
         * [cleanTime description]清空时间
         * @param  {[type]} viewValue [description]
         * @return {[type]}           [description]
         */
        $scope.cleanTime = function() {
            $scope.genParams.StartDocPubTime = '';
            $scope.genParams.EndDocPubTime = '';
        };
        /**
         * [description]
         * @param  {[type]} newValue  [description]
         * @param  {[type]} oldValue) {                       if (angular.isObject(newValue)) {                $scope.isRequest [description]
         * @return {[type]}           [description]
         */
        $scope.$watch('userName', function(newValue, oldValue) {
            if (angular.isObject(newValue)) {
                $scope.isRequest = true;
                $scope.genParams.CrUser = newValue.UNAME;
                $scope.userName = newValue.USERNAME;
            }
        });
        $scope.selectNode = function(node) {
            $scope.genParams.ChannelId = node.CHANNELID;
            $scope.websiteTemplate = {
                name: '请选择模板',
                value: 0,
            };
            template(node);
        };
        /**
         * [loadDatepicker description]加载时间控件组件
         */
        function loadDatepicker() {
            var deffer = $q.defer();
            if (typeof define === 'function' && define.amd) {
                // AMD
                require(['./lib/DatePicker/datepicker.js'], function() {
                    deffer.resolve();
                });
            } else {
                LazyLoad.js(['./lib/requirejs/require.js'], function() {
                    require(['./lib/DatePicker/datepicker.js'], function() {
                        deffer.resolve();
                    });
                });
            }
            return deffer.promise;
        }
        /**
         * [datePicker description]调用时间控件
         */
        function datePicker() {
            $datepickerCalendar.DatePicker({
                inline: true,
                date: [from, to],
                calendars: 1,
                mode: 'range',
                onChange: function(dates, el) {
                    var fromDate = dateFormat(dates[0]);
                    var untilDate = dateFormat(dates[1]);
                    $timeout(function() {
                        scope.showDate = dateFormat(dates[0]) + '至' + dateFormat(dates[1]);
                    });
                    if (indx == 2) {
                        $datepickerCalendar.removeClass('cur').hide();
                        var attr1 = iAttrs['fromdate'].split('.');
                        var attr2 = iAttrs['untildate'].split('.');
                        scope.$parent[attr1[0]][attr1[1]] = $filter('date')(fromDate, 'yyyy-MM-dd').toString();
                        scope.$parent[attr2[0]][attr2[1]] = $filter('date')(untilDate, 'yyyy-MM-dd').toString();
                        $timeout(function() {
                            if (new Date(fromDate).getTime() <= new Date(untilDate).getTime()) {
                                scope.callback();
                            } else {
                                modalDialog.alertType('时间检索失败', '开始时间不能大于结束时间', 'error', false);
                            }
                        });
                        indx = 1;
                    } else {
                        indx++;
                    }
                },
            });
        }
        /**
         * [isOnlyMine description]选择频道
         * @param  {[type]} viewValue [description]
         * @return {[type]}           [description]
         */
        // $scope.isOnlyMine=function(node){
        //     $scope.status.selectedItem = {
        //         CHANNELID: node.CHANNELID
        //     };
        //     $scope.genParams.ChannelId = node.CHANNELID;
        //     $scope.websiteTemplate = {
        //         name: "请选择模板",
        //         value: 0
        //     };
        //     template(node);
        // };
    },
]);
